import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaFurnaceRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaFurnaceRepair} />; }
